/**
 * AI-generated code, moderated by Lukasz Zygmanski
 */
import ReactMarkdown from 'react-markdown';

import {cn} from '@/utils/ui';

type ReleaseNoteMarkdownProps = {
  body: string;
  className?: string;
};

function ReleaseNoteMarkdown({body, className}: ReleaseNoteMarkdownProps) {
  return (
    <div
      className={cn(
        'prose-headings:font-urbanist prose prose-sm max-w-none prose-headings:text-neutral-dark prose-a:text-mint prose-img:rounded-soft prose-img:border prose-img:border-border',
        className
      )}
    >
      <ReactMarkdown>{body}</ReactMarkdown>
    </div>
  );
}

export default ReleaseNoteMarkdown;
